(ns ui.wallet.i18n.de
  "German dictionary of the wallet page (see `ui.wallet.i18n`).")

(def dictionary
  {:page/loading "lädt..."
   :page/command-failed "Etwas ist schiefgelaufen. Bitte versuche es noch einmal oder schreib uns im Chat, falls es wieder passiert."

   :balance/total-available "Verfügbares Guthaben"
   :balance/pay-as-you-go "Pay-as-you-go-Guthaben"
   :balance/used-up "Lade Guthaben auf, um weiter zu posten."
   :balance/view-usage "Verbrauch ansehen"

   :payment/title "Zahlung"
   :payment/method "Zahlungsmethode"
   :payment/billing-email "Rechnungs-E-Mail"
   :payment/reference "Referenz"
   :payment/update "Zahlungsmethode ändern"
   :payment/card [:fn/str "Karte ({{:last4}})"]
   :payment/wire-transfer "Überweisung"

   :billing-email/change "Ändern"
   :billing-email/new "Neue Rechnungs-E-Mail"
   :billing-email/save "Speichern"
   :billing-email/saving "Speichern..."
   :billing-email/cancel "Abbrechen"
   :billing-email/hint "Paddle, unser Reseller, sendet Belege und Rechnungen an diese Adresse."
   :billing-email/shared-hint "Teilen sich mehrere deiner Organisationen dieses Rechnungskonto, gilt die Änderung für alle."
   :billing-email/invalid "Bitte gib eine gültige E-Mail-Adresse ein."
   :billing-email/taken "Diese E-Mail-Adresse gehört bereits zu einem anderen Rechnungskonto. Bitte nutze eine andere Adresse oder schreib uns im Chat."

   :customer-conflict/title "Deine E-Mail ist schon mit einem anderen Konto verknüpft"
   :customer-conflict/text "Deine E-Mail-Adresse gehört bereits zum Rechnungskonto einer anderen Storrito-Organisation, und unser Zahlungsanbieter Paddle erlaubt nur ein Rechnungskonto pro E-Mail. Schreib uns im Chat, wir lösen das für dich."
   :customer-conflict/chat "Support-Chat öffnen"
   :customer-conflict/support-message "Hallo, ich kann die Kasse nicht öffnen: Meine E-Mail-Adresse gehört bereits zu einem anderen Rechnungskonto."

   :top-up/title "Automatische Aufladung"
   :top-up/custom-amount "Eigener Betrag"
   :top-up/opening-checkout "Kasse wird geöffnet..."
   :top-up/amount-missing "Bitte gib einen Betrag ein."
   :top-up/amount-too-small [:fn/str "Das Minimum ist ${{:minimum}}."]
   :top-up/amount-too-large [:fn/str "Das Maximum sind ${{:maximum}} pro Aufladung. Für größere Beträge schreib uns bitte im Chat."]
   :top-up/per-month [:fn/str "${{:quantity}} jeden Monat"]
   :top-up/per-year [:fn/str "${{:quantity}} jedes Jahr"]
   :top-up/stops-on [:fn/str "Endet am {{:date}}"]
   :top-up/next-on [:fn/str "Nächste Aufladung am {{:date}}"]
   :top-up/status-cancellation-scheduled "Kündigung vorgemerkt"
   :top-up/status-payment-failed "Zahlung fehlgeschlagen"
   :top-up/status-active "aktiv"
   :top-up/past-due "Die letzte Aufladung konnte nicht abgebucht werden. "
   :top-up/update-payment-method "Zahlungsmethode aktualisieren"
   :top-up/resume "Automatische Aufladung fortsetzen"
   :top-up/cancel "Automatische Aufladung kündigen"
   :top-up/paddle-unavailable "Wir konnten die Details deiner automatischen Aufladung gerade nicht von Paddle laden. Bitte versuche es gleich noch einmal."
   :top-up/try-again "Erneut versuchen"

   :plan/title-monthly "Monatliche Aufladung"
   :plan/title-yearly "Jährliche Aufladung"
   :plan/switch "Auf Pay-as-you-go umstellen"
   :plan/switching "Wird umgestellt..."
   :plan/switch-confirm [:fn/str "Deine wiederkehrende Aufladung von ${{:quantity}} endet jetzt; die Umstellung selbst ist kostenlos. Dein Guthaben und deine Zahlungsmethode bleiben. Ab dann zahlst du nur noch, wenn du Guthaben auflädst, oder automatisch mit der Automatischen Aufladung."]
   :plan/wont-cover [:fn/str "Dein Guthaben reicht vermutlich nicht für deine verbundenen Instagram-Konten bis zur nächsten Aufladung am {{:date}}; bei $0 werden keine Stories mehr gepostet."]
   :plan/wont-cover-advice "Aktiviere unten die Automatische Aufladung oder lade jetzt Guthaben auf."

   :on-demand/add-credits "Guthaben aufladen"
   :on-demand/choose-amount "Wähle einen Betrag. Du zahlst nur, was du nutzt."
   :on-demand/auto-top-up "Automatische Aufladung"
   :on-demand/rule [:fn/str "Fällt dein Guthaben unter ${{:threshold}}, laden wir automatisch ${{:amount}} auf."]
   :on-demand/auto-top-up-hint "Optional. Deine Stories werden weiter veröffentlicht, wenn das Guthaben knapp wird — jederzeit abschaltbar."
   :on-demand/add [:fn/str "${{:amount}} aufladen"]
   :on-demand/charged-once "Wird jetzt einmalig über Paddle, unseren Reseller, abgebucht. Deine Karte wird für spätere Aufladungen gespeichert, nichts ist wiederkehrend. Guthaben wird nicht erstattet. Preise zzgl. MwSt."
   :on-demand/discount-off [:fn/str "{{:percent}} % Rabatt auf"]
   :on-demand/discount-applied "Gilt ab deiner ersten Aufladung für deinen Tagessatz, nicht für den aufgeladenen Betrag. Dein Startguthaben wird zum regulären Tarif abgerechnet."
   :on-demand/charged-to-card "Wird von deiner gespeicherten Zahlungsmethode abgebucht und ist in Sekunden verfügbar."
   :on-demand/confirm-charge [:fn/str "Dir werden jetzt ${{:amount}} USD zzgl. Steuern abgebucht."]
   :on-demand/charging "Wird abgebucht..."
   :on-demand/add-now [:fn/str "Jetzt ${{:amount}} aufladen"]
   :on-demand/payment-accepted "Zahlung akzeptiert, dein Guthaben aktualisiert sich in wenigen Sekunden."
   :on-demand/prices-excl-vat "Preise zzgl. MwSt."
   :on-demand/amount-too-large [:fn/str "Das Maximum sind ${{:maximum}} pro Aufladung."]
   :on-demand/on "An"
   :on-demand/off "Aus"
   :on-demand/saving "Wird gespeichert..."
   :on-demand/save "Speichern"
   :on-demand/custom-auto-top-up-amount "Eigener Betrag für die automatische Aufladung"
   :on-demand/one-charge-per-day "Höchstens eine automatische Abbuchung pro Tag, von deiner gespeicherten Zahlungsmethode, zzgl. anfallender Steuern."
   :on-demand/remove-payment-method "Zahlungsmethode entfernen"

   :transactions/title "Letzte Transaktionen"
   :transactions/full-statement "Vollständige Abrechnung"
   :transactions/invoices "Rechnungen"
   :transactions/date "Datum"
   :transactions/description "Beschreibung"
   :transactions/amount "Betrag"
   :transactions/error "Die Transaktionen konnten nicht geladen werden."
   :transactions/empty "Diesen Monat noch keine Käufe."
   :transactions/welcome-credits "Startguthaben"
   :transactions/recurring-top-up "Wiederkehrende Aufladung"
   :transactions/added-credits "Guthaben aufgeladen"
   :transactions/refund "Erstattung"

   :credit-notes/view "Gutschriften"
   :credit-notes/title "Gutschriften"
   :credit-notes/intro "Gutschriften zu deinen Erstattungen und Guthaben. Paddle, unser Reseller, stellt sie aus."
   :credit-notes/refund "Erstattung"
   :credit-notes/credit "Guthaben"
   :credit-notes/download "PDF herunterladen"
   :credit-notes/empty "Noch keine Gutschriften."
   :credit-notes/error "Die Gutschriften konnten nicht geladen werden."

   :offer/applied-automatically "Wird automatisch angewendet, wenn du Guthaben hinzufügst. Bis dahin wird dein Startguthaben zum regulären Tarif abgerechnet."

   :rates/view "Unsere Preise ansehen"
   :rates/title "Unsere Preise auf einen Blick"
   :rates/intro "Hier siehst du, was wir pro Leistung berechnen. "
   :rates/intro-bold "Alle Preise in US-Dollar ohne Steuern (zzgl. MwSt.)."
   :rates/per-day "pro Tag"
   :rates/per-post "pro Beitrag"
   :rates/per-image "pro Bild"
   :rates/per-days [:fn/str "pro {{:days}} Tage"]
   :rates/excl-vat "Alle Preise zzgl. MwSt."
   :rates/off [:fn/str "{{:percent}}% RABATT"]

   :service.storage-flat-fee/name "Speicher-Pauschale"
   :service.storage-flat-fee/description "für alle deine Bilder, Videos usw."
   :service.instagram-connection/name "Instagram-Konto-Verbindung"
   :service.instagram-connection/description "Unbegrenzt Stories und Reels für einen Instagram-Benutzernamen."
   :service.tiktok-post/name "TikTok-Beitrag"
   :service.tiktok-post/description "Ein Video oder Bild auf TikTok veröffentlichen."
   :service.youtube-short/name "YouTube Short"
   :service.youtube-short/description "Ein gerendertes Video als YouTube Short veröffentlichen."
   :service.social-post/name "Social-Post"
   :service.social-post/description "Ein gerendertes Video oder Bild auf Facebook, Threads und weiteren verbundenen Plattformen veröffentlichen (X wird separat berechnet)."
   :service.x-post/name "X-Post"
   :service.x-post/description "Ein gerendertes Video auf X veröffentlichen. X berechnet jeden Post über seine API, daher kosten X-Posts mehr als andere Social-Posts."
   :service.x-post-link/name "X-Post mit Link"
   :service.x-post-link/description "Ein X-Post, dessen Text einen Link enthält. X berechnet für Posts mit Links deutlich mehr."
   :service.ai-image/name "KI-Bild"
   :service.ai-image/description "Erzeugung eines Bildes mit KI (Dall-e / Blackforest)."})
